<template>
  <ul class="grid-layout-goddess">
    <li
      v-for="goddess in goddesses"
      :key="goddess.id"
      class="item-card"
      @click="navigateTo(goddess.id)"
    >
      <img class="cover" :src="goddess.albumUrl" alt="" />
      <p class="title">{{ goddess.nickname }}</p>
      <ul class="tags">
        <li class="tag">{{ goddess.nationality }}</li>
        <li class="tag">{{ goddess.age }}岁</li>
        <li class="tag">已认证</li>
      </ul>
    </li>
  </ul>
</template>
<script>
export default {
  name: "GridLayoutGoddess",
  props: {
    goddesses: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    navigateTo(id) {
      this.$router.push({ name: "personalHome", params: { id } });
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-layout-goddess {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  grid-gap: 10px;
  > li {
    height: 233px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 1px 1px 5px 1px rgba(216, 216, 216, 1);
    display: flex;
    flex-direction: column;
    .cover {
      border-radius: 5px 5px 0 0;
      width: 100%;
      height: 170px;
    }
    .title {
      width: 155px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: 8px 0 5px 9px;
      text-align: left;
    }
    .tags {
      display: flex;
      .tag {
        margin: 0 4px;
        padding: 6px;
        height: 20px;
        background: rgba(229, 192, 92, 0.1);
        border-radius: 11px;
        font-size: 12px;
        line-height: 8px;
        font-weight: 400;
        color: rgba(229, 192, 92, 1);
      }
    }
  }
}
</style>
